import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import AccountsHeader from "./header";
import {
  apiLimitSetByAdmin,
  updateApiLimit,
  updateUserProfile,
} from "../../../store/slices/authSlice";

const validationSchema = Yup.object({
  limit: Yup.number().required("Limit is required"),
});

const ApiLimiting = () => {
  const { apiLimit } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      limit: apiLimit?.limitSetByAdmin,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      dispatch(updateApiLimit({ values }));
    },
  });

  useEffect(() => {
    dispatch(apiLimitSetByAdmin());
  }, [dispatch]);

  return (
    <div className="section_main_div">
      <h1 className="section_heading">Account</h1>
      <AccountsHeader />

      <form className="form_div" onSubmit={formik.handleSubmit}>
        <div className="form-card">
          <div>
            {apiLimit?.loginConfiguration ? (
              <p style={{ fontSize: "13px" }}>
                {`Confirmed Requests: ${
                  apiLimit?.loginConfiguration.request_count
                } in between (${
                  apiLimit?.loginConfiguration.startTime
                    ? apiLimit?.loginConfiguration.startTime
                    : ""
                }-${
                  apiLimit?.loginConfiguration.endTime
                    ? apiLimit?.loginConfiguration.endTime
                    : ""
                }) `}
              </p>
            ) : (
              ""
            )}
          </div>

          <div className="form-elements w-100">
            <div className="custom-form-group">
              <label htmlFor="limit">Hourly Limit</label>
              <input
                type="number"
                id="limit"
                name="limit"
                value={formik.values.limit}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />
              {formik.touched.limit && formik.errors.limit ? (
                <div className="error-text">{formik.errors.limit}</div>
              ) : null}
              <hr
                className={
                  formik.touched.limit && formik.errors.limit
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="button-div">
            <button
              type="submit"
              disabled={formik.isSubmitting}
              style={{ textTransform: "capitalize" }}
            >
              <span>{formik.isSubmitting ? "Updating..." : "Update"}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ApiLimiting;
